// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZL2KT","rootNoMargin":"styles_rootNoMargin__3T8wP"};